// extracted by mini-css-extract-plugin
export default {"mobile":"mobile","about":"AS2l9_18","aboutProject":"x8blPvQ0","ads":"c4uHW7hM"};